import React from 'react';
import ReactDOM from 'react-dom/client';
import axios from 'axios';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux'
import store from './store';
import 'react-toastify/dist/ReactToastify.css';
import { WelcomePopupProvider } from './components/WelcomePopupProvider';
import { DialogProvider } from './components/DialogProvider';
import { setupAuthInterceptor } from './utils/axiosInterceptor';
import { ChipMonkThemeProvider } from './theme/ThemeProvider';
axios.defaults.timeout = 30000;
setupAuthInterceptor();


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <ChipMonkThemeProvider>
      <DialogProvider>
        <WelcomePopupProvider>
          <App />
        </WelcomePopupProvider>
      </DialogProvider>
    </ChipMonkThemeProvider>
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();



